import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { ButtonPrimary, IconAgent } from 'mage-deps/@klarna/bubble-ui'
import { hooks as i18nHooks } from 'mage-i18n'
import { useEducationAnalytics } from 'education-tools'
import { useHelpContext } from './hooks'

SupportButton.propTypes = {
  analyticsCategory: PropTypes.string.isRequired,
  scrollIntoView: PropTypes.bool
}

export default function SupportButton({ analyticsCategory, scrollIntoView = false }) {
  const t = i18nHooks.useTranslator()
  const { navigation } = useHelpContext()
  const ref = useRef()

  const track = useEducationAnalytics({
    category: analyticsCategory,
    action: 'click'
  })

  useEffect(() => {
    if (ref.current && scrollIntoView) {
      ref.current.scrollIntoView()
    }
  }, [ref.current])

  return (
    <div ref={ref}>
      <ButtonPrimary
        data-testid="hqm-support-button"
        size="medium"
        icon={IconAgent}
        onClick={onClick}
      >
        {t('hqm.support-button')}
      </ButtonPrimary>
    </div>
  )

  function onClick() {
    track()
    navigation.push('support')
  }
}
